export default __webpack_public_path__ + "static/the-paraskys-a214ecdf858eb6387c7297f518ca3b74.jpg";